// ------------------------------------- Breach Wall Specific Types Below -------------------------------------

export type BreachWallContentType =
    | 'default'
    | 'default-price-increase'
    | 'sport'
    | 'black-friday'
    | 'vanishing-cousins'
    | 'top-50-schools'
    | '50-off-afl-breach-screen'
    | '50-off-breach-discount' // to be used for most sales promotions
    | 'subs-campaign-eofy-weekend-digital'
    | 'business-pack'
    | 'sport-pack'
    | 'digital-only'
    | 'Puzzles'
    | 'Puzzles-increase'
    | 'puzzles-swg-30-off'
    | 'ePaper'
    | 'ePaper-price-increase'
    | 'default-breachwall-2024'
    | 'default-annual-package'
    | 'digital-radio-and-papers'

export type BreachWallStyle =
    | 'breach-190-year'
    | 'vanishing-cousins'
    | 'black-friday'
    | 'afl50'
    | 'eofy'
    | 'default-breachwall-2024'
    | 'digital-radio-and-papers'

export type BreachBannerLayout = {
    topBannerText?: string
    mainBannerText?: string
    subBannerText?: string
    tncBannerText?: string
}

// ------------------------------------- Package Specific Types Below -------------------------------------

export type SubscriptionPackageButtonStyle =
    | 'default'
    | 'solid-blue'
    | 'transparent'
    | 'solid-red'
export type SubscriptionPackageTheme =
    | 'default'
    | 'red'
    | 'yellow'
    | 'vanishing-cousins'
    | 'west-blue'
    | 'optimise-blue'
export type SubscriptionPackageType = 'digital' | 'digitalprint'

export type RibbonOptions =
    | 'newDesignTag'
    | 'cornerDesignTag'
    | 'oldDesignTag'
    | 'bluePill'

export interface SubscriptionPriceObject {
    price: string
    packagePath: string
    priceQualifier?: string
    googleSKU?: string
    cancellationMessage?: string

    // Pill options, which will be displayed with the radio qualifier
    ribbonTitle?: string
    ribbonOptions?: RibbonOptions

    // GA4 properties
    offerCode?: string
    rateCode: string
    weeklyPrice: number
    promoPrice?: number
    discount?: number
}

interface BaseSubscriptionPackage {
    heading: string
    ribbonTitle?: string
    ribbonOptions?: RibbonOptions
    packageType?: SubscriptionPackageType
    packageTheme?: SubscriptionPackageTheme
    // Properties for ga4 event - ACQ-17
    benefitOverride?: string[]
    buttonStyle?: SubscriptionPackageButtonStyle
}

// Overall type to provide subscription package data across the board.
export type SubscriptionPackageOptions =
    | ISingleSubscriptionPackage
    | IRadioSubscriptionPackage

export interface IRadioSubscriptionPackage extends BaseSubscriptionPackage {
    type: 'radio-list-subscriptions'
    prices: SubscriptionPriceObject[]
}
export interface ISingleSubscriptionPackage
    extends SubscriptionPriceObject,
        BaseSubscriptionPackage {
    type: 'single-subscription'
    originalPrice?: string
}

export const mapSubscriptionPackagesToFlatList = (
    packages: SubscriptionPackageOptions[],
): ISingleSubscriptionPackage[] => {
    return packages.flatMap((pkg) => {
        if (pkg.type === 'single-subscription') {
            return pkg
        } else {
            return pkg.prices.map((radioPkg) => {
                return {
                    ...pkg,
                    ...radioPkg,
                    type: 'single-subscription',
                } as ISingleSubscriptionPackage
            })
        }
    })
}
